import { render } from "./DotStep.vue?vue&type=template&id=6b5e3458&scoped=true"
import script from "./DotStep.vue?vue&type=script&lang=js"
export * from "./DotStep.vue?vue&type=script&lang=js"

import "./DotStep.vue?vue&type=style&index=0&id=6b5e3458&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5e3458"]])

export default __exports__